export default {"src":"/_next/static/media/room-category-oceafront.efb9c4ae.svg","height":48,"width":73};